<div class="form-group" [class.mb-10]="isActive()" [class.mb-15]="!isActive()">
    <label class="control-label col-xs-9">
        {{ "control_add_button_icon" | translate }}
    </label>
    <div class="col-xs-3 control-switch text-right">
        <sp-switch [active]="isActive()" (toggleActiveEvent)="setIsActive($event)" />
    </div>
</div>

@if (isActive()) {
    <div class="form-group mb-15">
        <div dropdown class="col-xs-3">
            <div
                class="form-control button-icon-preview dropdown-toggle"
                dropdownToggle
                [innerHTML]="getIcon(icon())"
            ></div>

            <div *dropdownMenu class="dropdown-menu">
                <div class="button-icon-list">
                    @for (iconItem of buttonIconList; track iconItem[0]) {
                        <div
                            class="item-preview"
                            [class.selected]="iconItem[1] === icon()"
                            [innerHTML]="getIcon(iconItem[1])"
                            (click)="setIcon(iconItem[1])"
                        ></div>
                    }
                </div>
            </div>
        </div>
        <div class="col-xs-9">
            <sp-radio-group
                [selected]="position()"
                [type]="ERadioGroupType.horizontalPosition"
                [excludedPosition]="EHorizontalPosition.M"
                (changeSelectedEvent)="setIconPosition($event)"
            ></sp-radio-group>
        </div>
    </div>
}
